export default __webpack_public_path__ + "static/media/upcoming-collection--collection-2.65e28850.png";